import React from 'react';
//import styled from 'styled-components';
//import './Button.css';

// Als je CSS Modules wilt gebruiken (styles is een object)
// https://create-react-app.dev/docs/adding-a-css-modules-stylesheet/
import styles from "./Button.module.css";

// const Button = props => {
//   return (
//     <button type={props.type} className="button" onClick={props.onClick}>
//       {props.children}
//     </button>
//   );
// };

  // tact template literal syntax
/*
const Button = styled.button`
      width: 100%;
      font: inherit;
      padding: 0.5rem 1.5rem;
      border: 1px solid #8b005d;
      color: white;
      background: #8b005d;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.26);
      cursor: pointer;

      @media (min-width: 768px){
        width: auto;
      }

    &:focus {
      outline: none;
    }

    &:hover,
    &:active {
      background: #ac0e77;
      border-color: #ac0e77;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.26);
    }
  `;
 */

 const Button = props => {
   return (
     <button
       type={props.type || "button"}
       className={`${styles.button} ${props.className}`}
       onClick={props.onClick}
     >
       {" "}
       {/*className="button"*/}
       {props.children}
     </button>
   );
 };

export default Button;
